import { Metamodel, IViolation } from 'shell-models-lib';
import { DataFlowDatasetSettings, DatasetFormatType } from './dataflow-dataset-settings';
import { DataFlowExpression } from '../dataflowexpression';
import { stringIsNullOrEmpty, format } from 'app/shared/utils/string.util';

import { DataFlowSource } from '../dataflow-source';
import { DataFlowSink } from '../dataflow-sink';
import { BooleanDataFlowType } from '../dataflow-datatype';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';

export type ResourceType = 'auto' | 'standard' | 'extended' | 'custom';

@Metamodel.model({
    name: adfModelTypeMap.adobeCampaign.dataflowSettings,
    validator: AdobeCampaignSettings.validateSettings
})
export class AdobeCampaignSettings extends DataFlowDatasetSettings {
    @Metamodel.attribute({
    })
    public resourceName: DataFlowExpression;

    @Metamodel.attribute({
    })
    public filterColumn: DataFlowExpression;

    @Metamodel.attribute({
    })
    public filterValue: DataFlowExpression;

    @Metamodel.attribute({
    })
    public excludeColumns: DataFlowExpression[];

    @Metamodel.attribute({
    })
    public batchSize: DataFlowExpression;

    @Metamodel.attribute({
    })
    public requestInterval: DataFlowExpression;

    public static validateSettings(settings: AdobeCampaignSettings): IViolation[] {
        const violations: IViolation[] = [];
        if (settings.transform.isInlineDataset && settings.transform.datasetSettings && settings.transform.datasetSettings.getFormat() === DatasetFormatType.AdobeCampaign) {
            if (stringIsNullOrEmpty(settings.resourceName.expression)) {
                violations.push({
                    context: settings.transform,
                    message: () => format(stringResources.RequiredTemplate, stringResources.ResourceName)
                });
            }
        }

        return violations;
    }

    public get transform(): DataFlowSource | DataFlowSink {
        return this.owner instanceof DataFlowSource ? this.owner as DataFlowSource : this.owner as DataFlowSink;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.AdobeCampaign;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getDatasetType(): string {
        return undefined;
    }

    public getIconClass(): string {
        return 'i-20x20-adobe-campaign';
    }

    public initialize(subFormat: string): void {
        this.resourceName = this.transform.createTemplatableExpression();
        this.filterColumn = this.transform.createTemplatableExpression();
        this.filterValue = this.transform.createTemplatableExpression();
        this.allowInsert = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');
        this.allowUpsert = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');
        this.allowDelete = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');
        this.allowUpdate = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');
        this.keyColumns = [this.transform.createTemplatableExpression()];
        this.excludeColumns = [this.transform.createTemplatableExpression()];
        this.batchSize = this.transform.createTemplatableExpression();
        this.requestInterval = this.transform.createTemplatableExpression();
    }
}
